module.exports = __webpack_public_path__ + "img/member_practices.3ade181b.svg";